import React, {PropTypes} from 'react';
import {ListItem} from 'material-ui/List';
import { MaterialToReadIcon, TakeActionIcon } from '../Icons';
import ContentItemAction from './ContentItemAction';
import IsReadTitle from './IsReadTitle';

const ReadingMaterialItem = ({item}) => {
  return (
    <div>
      <ContentItemAction>
        <ListItem primaryText={<IsReadTitle title={item.title} read={item.read}/>}
          leftIcon={<MaterialToReadIcon />}
          rightIcon={<TakeActionIcon />}
          item={item}
        />
      </ContentItemAction>
    </div>
  );
};

ReadingMaterialItem.propTypes = {
  item: PropTypes.shape({
    title: PropTypes.string,
    read: PropTypes.boolean
  })
};

export default ReadingMaterialItem;



/** WEBPACK FOOTER **
 ** ./src/components/common/content-items/ReadingMaterialItem.js
 **/